import * as React from 'react';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';

import GetProductTagsQuery from '../../components/Query/ProductTags';
import ProductTagDetail from './ProductTagDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';

interface IProductTagsTableProps extends RouteComponentProps {
  domain: string;
  productTagId?: string;
}

interface IProductTagsTableState {
  productTag?: GQL.IProductTag;
}

class ProductTagsTable extends React.Component<IProductTagsTableProps, IProductTagsTableState> {

  constructor(props: IProductTagsTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <GetProductTagsQuery
            domain={this.props.domain}
          >
            {({
              productTags,
              createProductTag,
              deleteProductTag,
              updateProductTag
            }: any) => {
              return this.renderData(
                productTags,
                createProductTag,
                updateProductTag,
                deleteProductTag,
                productTags.refetch
              );
            }}
          </GetProductTagsQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    productTags: any,
    createProductTag: Function,
    updateProductTag: Function,
    deleteProductTag: Function,
    refetch: Function
  ) {
    if (productTags && !productTags.loading) {

      // formulář
      if (this.props && this.props.productTagId) {
        const selectedProductTag = productTags.productTags.find((s: GQL.IProductTag) => s.id === this.props.productTagId) || undefined;
        if (this.props.productTagId !== 'new' && !selectedProductTag) {
          return <NotFoundPage domain={this.props.domain} />
        }
        return (
          <ProductTagDetail
            domain={this.props.domain}
            languages={productTags.languages}
            productTag={productTags.productTags.find((t: GQL.IProductTag) => t.id === this.props.productTagId) || undefined}
            onSave={(t: GQL.IProductTag) => this.upsert(t, createProductTag, updateProductTag, refetch)}
            onCancel={() => this.cancel()}
          />
        );
      }

      return (
        <div>
          <Title>Product Tags</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new product tag</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={productTags.productTags}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Name" dataIndex="name" key="name" />
            <Table.Column
              title="Display"
              dataIndex="color"
              key="color"
              render={(u, row: GQL.IProductTag) => {
                if (row.color) {
                  return (
                    <span
                      style={{
                        background: row.color,
                        color: '#fff',
                        padding: '6px 10px',
                        fontSize: '90%'
                      }}
                    >
                      {row.title['en']}
                    </span>);
                }
                return null;
              }}
            />
            <Table.Column
              title="Active"
              dataIndex="active"
              key="active"
              width={100}
              align="center"
              render={(u, row: GQL.IProductTag) => {
                return (
                  <span>
                    {row.active ? (
                      <CheckOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                    ) : (
                        <CloseOutlined style={{ fontSize: 20 }} />
                      )}
                  </span>
                );
              }}
            />
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              width={180}
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteProductTag, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading product tags ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(
    u: any,
    productTag: GQL.IProductTag,
    deleteProductTag: Function,
    refetch: Function
  ) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(productTag.id)}>
          Edit
         </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(productTag, deleteProductTag, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(productTag: GQL.IProductTag, deleteProductTag: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${productTag.title}?`,
      content: (
        <span>
          Are you sure you want to delete product tag <strong>{productTag.name}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteProductTag({
          variables: {
            id: productTag.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    productTag: GQL.IProductTag,
    createProductTag: Function,
    updateProductTag: Function,
    refetch: Function
  ) {
    if (productTag != undefined) {
      const variables = {
        id: productTag.id,
        productTag: {
          name: productTag.name,
          title: productTag.title,
          color: productTag.color,
          active: productTag.active,
        }
      };

      if (productTag.id) {
        return updateProductTag({ variables })
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Product tag "${variables.productTag.name}" has been updated.`
            })
          );
      }

      (variables.productTag as any).domain = this.props.domain;

      createProductTag({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Product tag "${variables.productTag.name}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/${recordId ? `product-tags/${recordId}` : 'product-tags'}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(ProductTagsTable);


// WEBPACK FOOTER //
// ./src/scenes/ProductTag/ProductTagTable.tsx